// extracted by mini-css-extract-plugin
export default {"header":"navbar_header__RicxF","menu":"navbar_menu__lo+qh","btn_mobile":"navbar_btn_mobile__HACZQ","active":"navbar_active__YOD90"};